/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-concat */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import { Modal } from 'react-responsive-modal';
import UsePoint from '../containers/point/UsePoint';

import { toast } from 'react-toastify'; //토스트(toast)
//import { confirmAlert } from 'react-confirm-alert';         //알럿창(alert confirm)

import Tooltip from '@material-ui/core/Tooltip';
import { Base64 } from 'js-base64';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

// const _keyStr = "C012V45c6ky89AbdeBDFxHGIKwzLNrOPMST*UW-XZa7fgEhijJlnQRo3pYqstuvm_"

class ContentItemPart extends Component {
  state = {
    modalShow: false,
    payGubun: '',
    mouseOn: false,
  };
  componentDidMount = () => {
    window.addEventListener('message', this._receiveMessage);
  };
  _receiveMessage = (e) => {
    if (e.data === '' || e.data === undefined || e.data === null) {
      return false;
    }

    ////console.log(e.data)
  };
  _isTab = () => {
    const { userAgent, maxTouchPoints } = window.navigator;
    const isMac = /Macintosh/i.test(userAgent);
    if (isMac && maxTouchPoints > 0) return true;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi|mobi/i.test(
      userAgent
    );
  };
  _onPlay = async () => {
    const {
      history,
      loginId,
      setPlayUrl,
      setContentSerial,
      aParam,
      serviceEndDate,
    } = this.props;
    const { contentPartSerial, subPartSerial2, subPartSerial3, part } =
      this.props.childProps;

    if (moment(new Date()).format('YYYY-MM-DD HH:mm:ss') > serviceEndDate) {
      alert('VOD 서비스가 종료되었습니다.');
      return null;
    }

    // if (isMobile) {
    //   alert(
    //     '모바일 웹브라우져에서는 VOD 스트리밍을 지원하지 않습니다.\n\n확인을 누르시면 전용앱 또는 스토어로 이동합니다.'
    //   );
    //   this._moveStore();
    //   return false;
    // }
    // console.log(
    //   '============> click contentItemPart ============================'
    // );
    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인후 관람이 가능합니다.');
      setContentSerial(0);
      history.push('/login');
      return false;
    } else {
      if (
        subPartSerial2 === '' ||
        subPartSerial2 === null ||
        subPartSerial2 === undefined ||
        subPartSerial2 === 0
      ) {
        //alert('파라메터가 누락되었습니다.')
        toast.warn('파라메터가 누락되었습니다.');
      } else {
        //이용권, 포인트 체크
        const date = new Date();
        const timeStemp = moment(date)
          .add(10, 'minutes')
          .format('YYYYMMDDHHmmss');
        //let param = this.encode(timeStemp)

        //let crypParam = timeStemp + '|aniplus|' + subPartSerial2 + '/' + loginId
        let crypParam =
          timeStemp + '|was|' + subPartSerial2 + '/' + loginId + '@' + aParam;
        //console.log(crypParam)

        const base64Data = await this._getBase64Encode(crypParam);
        crypParam = base64Data.data.codeString;
        //console.log(crypParam)

        let urlEncode =
          contentPartSerial +
          '|' +
          subPartSerial2 +
          '|' +
          subPartSerial3 +
          '|' +
          part;
        const base64Data1 = await this._getBase64Encode(urlEncode);
        urlEncode = base64Data1.data.codeString;

        const result = await this._onPlayApi(subPartSerial2, crypParam);
        if (result) {
          const intReturn = result.data[0].intReturn;
          // console.log(intReturn)
          if (intReturn === 0 || intReturn === 10) {
            //onCloseModal()
            // console.log(urlEncode);
            setPlayUrl(urlEncode);
            //history.push('/player/?u=' + urlEncode)
          } else if (intReturn === -7 || intReturn === -1) {
            toast.error('서비스중인 화수가 아닙니다.');
          } else if (intReturn === -4 || intReturn === -5) {
            //alert(intReturn)
            //alert('이용권 또는 포인트 구매 후 관람이 가능합니다.')
            toast.warn('멤버십 또는 포인트 충전후 관람이 가능합니다.');
            //this._onShowModal('vod')
          } else if (intReturn === -2) {
            toast.warn('19세 미만은 관람이 불가한 작품입니다.');
            //alert('19세 미만은 관람이 불가한 작품입니다.')
          } else if (intReturn === -3) {
            this._onShowModal('vod');
          } else if (intReturn === -1000) {
            toast.warn('서비스가 종료되었습니다.');
          } else {
            toast.warn('오류가 발생했습니다.');
            //alert('오류가 발생했습니다.')
          }
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _onPlayApi = (subPartSerial, crypParam) => {
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    // // console.log(
    //   '====================> api call contentItemPart============================'
    // );
    let token = new Date();
    token = moment(token).format('YYYYMMDDhhmmss');
    token = Base64.encode(token);

    return axios
      .post(
        apiUrl + '/vodUrl',
        {
          params: {
            userid: loginId,
            authId: authId,
            subPartSerial: subPartSerial,
            //param: param,
            crypParam: crypParam,
            token: token,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //toast.warn('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          // history.push('/login');
        }
      });
  };

  _onDownload = async () => {
    const { contentSerial, subPartSerial3 } = this.props.childProps;
    const {
      history,
      loginId,
      setContentSerial,
      setDownloadBitrate,
      aParam,
      authId,
      pkg,
      serviceEndDate,
    } = this.props;

    if (moment(new Date()).format('YYYY-MM-DD HH:mm:ss') > serviceEndDate) {
      alert('다운로드 서비스가 종료되었습니다.');
      return null;
    }

    //console.log(contentSerial)
    //console.log(subPartSerial2)
    //console.log(subPartSerial3)
    if (isMobile) {
      alert(
        '모바일 웹브라우져에서는 다운로드를 지원하지 않습니다.\n\n확인을 누르시면 전용앱 또는 스토어로 이동합니다.'
      );
      this._moveStore();
      return false;
    }

    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인후 다운로드가 가능합니다.');
      setContentSerial(0);
      history.push('/login');
      return false;
    } else {
      const result = await this._onDownloadApi();

      if (result) {
        const intReturn = result.data[0].intReturn;
        const param = result.data[0].param;
        console.log(param);
        // const download720 = result.data[0].download720;
        // const download1080 = result.data[0].download1080;
        // const chkAVI = result.data[0].chkAVI;
        // const chk720P = result.data[0].chk720P;
        const downloadRate = result.data[0].downloadRate;
        setDownloadBitrate(downloadRate);
        //console.log(intReturn)
        //console.log('720' + download720)
        //console.log('1080' + download1080)
        const date = new Date();
        let timeStemp = moment(date).format('YYYYMMDDHHmmss');
        timeStemp = Base64.encode(timeStemp);

        // let ap =  Base64.encode(aParam)

        const base64Data = await this._getBase64Encode(timeStemp);
        timeStemp = base64Data.data.codeString;

        if (intReturn === 1 || intReturn === 3 || intReturn === 10) {
          //console.log('다운로드...')
          //alert(downloadBitrate)
          //1080p

          //const base64Data = await this._getBase64Encode(loginId)
          //console.log(aParam)
          const authUserid = aParam; //base64Data.data.codeString
          //console.log('===>')
          //console.log(authUserid)
          // const at = localStorage.getItem('at');
          const at = this.getCookie('at');

          if (downloadRate === '1080P') {
            //console.log('https://www.aniplustv.com/download/down_test1.asp?userid=' + authUserid + '&chkSerial=' + subPartSerial3 + ',' + '&gubun=MP4&contentSerial=' + contentSerial + '&tk=' + timeStemp + '&ai=' + authId + '&ad=' )
            //window.open('https://www.aniplustv.com/download/down.asp?userid=' + authUserid + '&chkSerial=' + subPartSerial3 + ',' + '&gubun=MP4&contentSerial=' + contentSerial + '&tk=' + timeStemp + '&ai=' + authId + '&p=' + pkg, 'hiddenframe1', 'width=0, height=0, left=0, height=0')
            window.open(
              'https://www.aniplustv.com/download/down_n.asp?userid=' +
                authUserid +
                '&chkSerial=' +
                subPartSerial3 +
                ',' +
                '&gubun=MP4&contentSerial=' +
                contentSerial +
                '&tk=' +
                timeStemp +
                '&ai=' +
                authId +
                '&p=' +
                pkg +
                '&at=' +
                at +
                '&pm=' +
                param,
              'hiddenframe1',
              'width=0, height=0, left=0, height=0'
            );
          } else {
            //console.log('https://www.aniplustv.com/download/down720p.asp?userid=' + authUserid + '&chkSerial=' + subPartSerial3 + ',' + '&gubun=MP4&contentSerial=' + contentSerial)
            window.open(
              'https://www.aniplustv.com/download/down720p_n.asp?userid=' +
                authUserid +
                '&chkSerial=' +
                subPartSerial3 +
                ',' +
                '&gubun=MP4&contentSerial=' +
                contentSerial +
                '&tk=' +
                timeStemp +
                '&ai=' +
                authId +
                '&p=' +
                pkg +
                '&at=' +
                at +
                '&pm=' +
                param,
              'hiddenframe1',
              'width=0, height=0, left=0, height=0'
            );
          }
          //const downPop = window.open('http://www.aniplustv.com/download/down_test.asp')
          //downPop.postMessage('test', "*")
        } else if (intReturn === 5) {
          //보유하신 포인트로 결제 후 다운이 가능(10일 무료 이용권은 다운로드 서비스가 제한됩니다.) 포인트로 결제 하시겠습니까?
          //alert('보유하신 포인트로 결제 후 다운이 가능(10일 무료 이용권은 다운로드 서비스가 제한됩니다.) 포인트로 결제 하시겠습니까?')

          this._onShowModal('down');
        } else if (intReturn === 6) {
          toast.warn('멤버십이 종료되었거나, 포인트가 부족 합니다.');
          //alert('무제한 이용권이 종료되었거나, 포인트가 부족합니다.')
        } else if (intReturn === 7) {
          toast.warn('멤버십 이용 예외작품 입니다. (포인트를 이용해 주세요)');
          //alert('무제한 이용권 다운로드 제한 된 작품 (포인트 이용)')
          //무제한 이용권 다운로드 제한 된 작품 (포인트 이용)
        } else if (intReturn === -1) {
          //서비스 중인 작품이 아닙니다.
          //alert('서비스 중인 작품이 아닙니다.')
          toast.warn('서비스 중인 작품이 아닙니다.');
        } else if (intReturn === -2) {
          //19세미만은 관람하실 수 없습니다.
          //alert('19세미만은 관람하실 수 없습니다.')
          toast.warn('19세미만은 관람하실 수 없습니다.');
        } else if (intReturn === -1000) {
          toast.warn('서비스가 종료되었습니다.');
        }
      }
    }
  };
  _onDownloadApi = () => {
    const { apiUrl, loginId, authId, history } = this.props;
    const { contentSerial, subPartSerial2, subPartSerial3 } =
      this.props.childProps;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');

    return axios
      .post(
        apiUrl + '/donwloadCheckNew',
        {
          params: {
            userid: loginId,
            authId: authId,
            subPartSerial2: subPartSerial2,
            subPartSerial3: subPartSerial3,
            contentSerial: contentSerial,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(1);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
        //toast.error('오류가 발생했습니다.')
        //alert('오류가 발생했습니다.')
      });
  };
  _refreshToken = async (gubun) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;

    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 0) {
        this._onPlay();
      } else if (gubun === 1) {
        this._onDownload();
      } else if (gubun === 2) {
        this._setPointUse();
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _getBase64Encode = (codeString) => {
    const { aspUrl, pkg, loginId } = this.props;
    return axios(
      aspUrl +
        '/base64encode_wd.asp?codeString=' +
        codeString +
        '&p=' +
        pkg +
        '&i=' +
        loginId
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getBase64Decode = (codeString) => {
    const { aspUrl } = this.props;
    //console.log(aspUrl + '/base64decode.asp?codeString=' + codeString)
    return axios(aspUrl + '/base64decode.asp?codeString=' + codeString)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _onCloseModal = () => {
    this.setState({
      modalShow: false,
    });
  };
  _onShowModal = (payGubun) => {
    //alert(0)
    this.setState({
      payGubun: payGubun,
      modalShow: true,
    });
  };

  _setPointUse = async () => {
    const { loginId } = this.props;
    const { payGubun } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._setPointUseApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        if (intReturn === 0) {
          this.setState({
            modalShow: false,
          });
          if (payGubun === 'down') {
            this._onDownload();
          } else {
            this._onPlay();
          }

          ////console.log('다운로드 시작.')
        }
      }
    }
  };
  _setPointUseApi = () => {
    const { payGubun } = this.state;
    const { contentSerial, subPartSerial2 } = this.props.childProps;

    const { apiUrl, loginId, authId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');

    //console.log(apiUrl + '/setUsePoint?userid=' + loginId + '&CheckedItems=' + subPartSerial2 + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun )
    //return axios(apiUrl + '/setUsePoint?userid=' + loginId + '&CheckedItems=' + subPartSerial2 + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun + '&chksale=ppv' )
    return axios
      .post(
        apiUrl + '/setUsePoint',
        {
          params: {
            userid: loginId,
            authId: authId,
            CheckedItems: subPartSerial2 + ',',
            contentSerial: contentSerial,
            gubun: payGubun,
            chksale: 'ppv',
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //toast.error('포인트 정보를 로드중 오류가 발생했습니다.')
        //alert('포인트 정보를 로드중 오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(2);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _toggleMouse = () => {
    const { mouseOn } = this.state;
    this.setState({
      mouseOn: !mouseOn,
    });
  };
  _msToTime = (duration) => {
    // let milliseconds = parseInt((duration%1000) / 1000)
    let seconds = parseInt((duration / 1000) % 60);
    let minutes = parseInt((duration / (1000 * 60)) % 60);
    let hours = parseInt((duration / (1000 * 60 * 60)) % 24);

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    return hours + ':' + minutes + ':' + seconds;
  };
  _timeToMs = (time) => {
    const tt = time.split(':');
    const sec =
      parseInt(tt[0]) * 3600 + parseInt(tt[1]) * 60 + parseInt(tt[1]) * 1;
    return sec;
  };
  _onChange = () => {
    const { index, subPartSerial2, subPartSerial3, _selected } =
      this.props.childProps;

    _selected(index, subPartSerial3, subPartSerial2);
  };
  _moveStore = () => {
    const { match } = this.props;
    let contentSerial = this.props.childProps.contentSerial;

    if (isIOS) {
      console.log('ios');
      setTimeout(function () {
        window.open('https://itunes.apple.com/kr/app/id687631772', '', '');
      }, 1500);

      window.location.href =
        'aniplustv://Detail?contentSerial=' + contentSerial;
    } else if (isAndroid) {
      console.log('andorid');
      setTimeout(function () {
        window.open(
          'https://play.google.com/store/apps/details?id=com.aniplustv.android',
          '',
          ''
        );
      }, 1500);

      window.location.href =
        'aniplustv://Detail?contentSerial=' + contentSerial;
    } else {
      setTimeout(function () {
        window.open(
          'https://play.google.com/store/apps/details?id=com.aniplustv.android',
          '',
          ''
        );
      }, 1500);
    }
  };
  render() {
    // const { loginId } = this.props;
    const { modalShow, payGubun, mouseOn } = this.state;
    const { imgUrl, serviceEndDate } = this.props;
    const {
      contentSerial,
      contentPartSerial,
      subTitle,
      subPartSerial2,
      subPartSerial3,
      img,
      activeFlag,
      chkFree,
      downActive,
      pos,
      mediaTime,
      episode,
      updateDate,
      vodSupport,
      downSupport,
      vodPrice,
      downPrice,
      downExist,
      selected,
    } = this.props.childProps;
    // const today = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
    // const upDate = moment(updateDate).add(7, 'day').format("YYYY-MM-DD HH:mm:ss")
    let ratio = pos > 0 ? (pos / this._timeToMs(mediaTime)) * 100 : 0;
    if (ratio > 100) {
      ratio = 100;
    }
    //console.log(pos)
    //console.log(this._timeToMs(mediaTime))
    //console.log(ratio)
    const isTab = this._isTab();
    return (
      <Fragment>
        <div
          className={mouseOn ? 'episode_list episode_on' : 'episode_list'}
          onMouseEnter={this._toggleMouse}
          onMouseLeave={this._toggleMouse}
          // style={{ padding: 0 }}
        >
          {contentPartSerial === 22245 ||
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
            serviceEndDate ? null : downSupport === 'Y' ? (
            <Fragment>
              <input
                type="checkbox"
                className="chkBox"
                name="chk"
                id={'chk' + contentPartSerial}
                checked={selected > 0 ? true : false}
                onChange={this._onChange}
              />
              <label
                htmlFor={'chk' + contentPartSerial}
                className="chk"
              ></label>
            </Fragment>
          ) : null}
          <div
            className="episode_img"
            onClick={
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') > serviceEndDate
                ? null
                : this._onPlay
            }
            style={{
              cursor:
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                serviceEndDate
                  ? null
                  : 'pointer',
            }}
          >
            {isMobile ? null : mouseOn ? (
              vodSupport === 'Y' ? (
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                serviceEndDate ? null : (
                  <a
                    style={{
                      cursor:
                        moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                        serviceEndDate
                          ? null
                          : 'pointer',
                    }}
                  >
                    <img src={imgUrl + '/img/detail_img/play_btn_on.png'} />
                  </a>
                )
              ) : null
            ) : null}
            {/* upDate >= today ? (
                            <span><img src={ imgUrl + "/img/detail_img/update_img.png"}/></span>
                        ) : null */}
            <img src={img} />

            <div className="line_div">
              <div style={{ width: ratio + '%', height: '100%' }}></div>
            </div>
          </div>
          {/*
                    <div className="chek_all_group">
                        <input name="선택" id="_1" type="checkbox" value="" className="checkbox_img"/><label htmlFor="checkbox_1_1"></label>
                    </div>
                    */}
          {vodSupport === 'Y' ? (
            <h2
              onClick={
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                serviceEndDate
                  ? null
                  : this._onPlay
              }
              style={{
                cursor:
                  moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                  serviceEndDate
                    ? null
                    : 'pointer',
              }}
            >
              {subTitle}
            </h2>
          ) : (
            <h2>{subTitle}</h2>
          )}

          <div>
            {/* <span>
              {updateDate === ''
                ? '업데이트 대기중'
                : updateDate.substr(0, 10).replace(/-/g, '.') + ' 방영'}
            </span>
            <span className="mediaTime">{mediaTime}</span> */}
            {chkFree > 0 ? (
              <span>무료</span>
            ) : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
              serviceEndDate ? null : (
              <span>
                <em>감상 {this._CommaFormatted(vodPrice)}원</em>
                <em>다운 {this._CommaFormatted(downPrice)}원</em>{' '}
                {/* downExist > 0 ? <em style={{color: 'orange'}}>다운완료 √</em> : null */}
              </span>
            )}
          </div>

          {vodSupport === 'Y' ? (
            <p
              onClick={
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                serviceEndDate
                  ? null
                  : this._onPlay
              }
              style={{
                cursor:
                  moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                  serviceEndDate
                    ? null
                    : 'pointer',
              }}
            >
              {episode}
            </p>
          ) : (
            <p>{episode}</p>
          )}

          {isTab ? null : activeFlag === 'Y' ? (
            <div className="episode_a">
              {downExist > 0 ? (
                <Tooltip title="다운완료">
                  <a>
                    <img src={imgUrl + '/img/detail_img/chek_btn.png'} />
                  </a>
                </Tooltip>
              ) : null}
              {contentPartSerial === 23284 ||
              contentPartSerial === 22245 ||
              contentPartSerial === 24250 ||
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                serviceEndDate ? null : downActive ? (
                downSupport === 'Y' ? (
                  <a style={{ cursor: 'pointer' }} onClick={this._onDownload}>
                    <Tooltip title="PC에 다운로드">
                      <img src={imgUrl + '/img/detail_img/down_btn2.png'} />
                    </Tooltip>
                  </a>
                ) : (
                  <a>
                    <Tooltip title="다운로드 미지원 작품">
                      <img src={imgUrl + '/img/detail_img/down_btn3.png'} />
                    </Tooltip>
                  </a>
                )
              ) : null}

              {/*vodSupport === 'Y' ? (<a style={{cursor: 'pointer'}} onClick={this._onPlay}><Tooltip title="스트리밍 재생하기"><img src={ imgUrl + "/img/detail_img/play_btn2.png"}/></Tooltip></a>) : null */}
            </div>
          ) : null}
        </div>
        {/*
                <div>
                    <img src={imageS} alt="" />
                    <span>{ subTitle }</span><span>{ mediaTime }</span>
                    <button onClick={this._onPlay}>VOD</button>
                    <button onClick={this._onDownload}>DOWNLOAD</button>
                </div>
                */}

        <iframe
          width="0"
          height="0"
          name="hiddenframe1"
          style={{ display: 'none' }}
        ></iframe>

        <Modal
          open={modalShow}
          showCloseIcon={false}
          onClose={this._onCloseModal}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          center
          styles={{ modal: { backgroundColor: 'black' } }}
        >
          <UsePoint
            contentSerial={contentSerial}
            contentPartSerial={contentPartSerial}
            subPartSerial2={subPartSerial2 + ','}
            subPartSerial3={subPartSerial3}
            payGubun={payGubun}
            chksale="ppv"
            onPointUse={this._setPointUse}
            onClose={this._onCloseModal}
          />
        </Modal>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ContentItemPart));
